"use client";
import React from "react";
import { useQuery } from "@apollo/client/react";
import { notFound, useParams } from "next/navigation";

import { ThemedHeading, ThemedPage, UserPill } from "@/components";
import { Main } from "@/components/layouts";
import ReactionsShower from "@/components/reactions/reactions-shower";
import { GET_COMIC } from "@/gql/queries/get-comic";

import ComicPage from "./comic-page";

const ComicPageWrapper = () => {
  const params = useParams<{ comicUrl: string }>();

  const { data, loading } = useQuery(GET_COMIC, {
    variables: { slug: params.comicUrl },
  });

  if (loading) return null;
  if (!data?.comic) notFound();

  return (
    <ThemedPage theme={data.comic.user.theme}>
      <Main theme={data.comic.user.theme}>
        <ThemedHeading theme={data.comic.user.theme}>
          {data.comic.parentAnimation.title} by{" "}
          <UserPill user={data.comic.user} />
        </ThemedHeading>
        <ComicPage comicData={data.comic} />
      </Main>
      <ReactionsShower
        reactions={data.comic.parentAnimation.reactionsBreakdown}
      />
    </ThemedPage>
  );
};

export default ComicPageWrapper;
